<div class="container">
  <mat-card class="cancel-dispenser-agreement__body">
    <h3 class="cancel-dispenser-agreement__body__title">
      {{ 'dispenserAgreement.cancellationSubmitted' | cxTranslate }}
    </h3>
    <p class="newLine">
      {{ 'dispenserAgreement.cancellationSubmitMessage' | cxTranslate: { agreementNumber: agreementNumber } }}
    </p>
    <p class="newLine">{{ 'dispenserAgreement.cancellationSubmitMessage2' | cxTranslate }}</p>
    <div class="action-button">
      <button class="btn btn-primary" (click)="backToHistory()">
        {{ 'dispenserAgreement.checkStatusButton' | cxTranslate }}
      </button>
    </div>
  </mat-card>
</div>
